import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import AscendingSvg from '../../Form/SortSvg/AscendingSvg';
import DescendingSvg from '../../Form/SortSvg/DescendingSvg';
import { setSortEmployerList } from '../../../redux/slices/employer.slice';
import { useDispatch, useSelector } from 'react-redux';

function ListAll({ currentItems }) {
  const dispatch = useDispatch();
  const { sortEmployerList } = useSelector((state) => state.employer);

  return (
    <table className="w-full divide-y divide-gray-200">
      <thead>
        <tr className="whitespace-nowrap">
          {/* <th scope="col" className=" py-3 text-start text-[16px] font-medium uppercase">
                        <input
                            id='select_all'
                            name='all'
                            type="checkbox"
                            aria-checked={false}
                            className="h-4 w-4 rounded border-gray-300 text-blue-500 focus:ring-blue-500"
                            // onClick={handleCheck}
                        />
                    </th> */}
          <th scope="col" className="pr-2 py-3 text-start text-[14px] font-medium hidden md:table-cell">
            <div
              className="flex flex-row items-center gap-2 cursor-pointer"
              id="id"
              onClick={() => {
                dispatch(setSortEmployerList(!sortEmployerList));
              }}>
              ID
              {!sortEmployerList ? <AscendingSvg color="#000000" /> : <DescendingSvg color="#000000" />}
            </div>
          </th>
          <th scope="col" className="px-2 py-3 text-start text-[14px] font-medium">
            <div className="flex flex-row items-center gap-2 cursor-pointer" id="title">
              Наименование
            </div>
          </th>
          {/* <th scope="col" className="px-2 py-3 text-start text-[14px] font-medium">
                        <div className='flex flex-row items-center gap-2 cursor-pointer' id='status'  >
                            Статус
                            {
                                sortTypeState === 'status' ? 
                                    sortDirectionState ?
                                        <AscendingSvg color="#000000" />
                                        :
                                        <DescendingSvg color="#000000" />
                                    : ''
                            }
                        </div>
                    </th> */}
          <th scope="col" className="px-2 py-3 text-center text-[14px] font-medium">
            <div className="flex flex-row items-center gap-2 cursor-pointer" id="active">
              Активных
            </div>
          </th>
          <th scope="col" className="px-2 py-3 text-center text-[14px] font-medium">
            <div className="flex flex-row items-center gap-2 cursor-pointer" id="activeHR">
              Активные (HR)
            </div>
          </th>
          <th scope="col" className="px-2 py-3 text-center text-[14px] font-medium">
            <div className="flex flex-row items-center gap-2 cursor-pointer" id="moderation">
              На модерации
            </div>
          </th>
          <th scope="col" className="px-2 py-3 text-center text-[14px] font-medium" id="inactive">
            <div className="flex flex-row items-center gap-2 cursor-pointer" id="inactive">
              Не активных
            </div>
          </th>
          <th scope="col" className="pl-2 py-3 text-center text-[14px] font-medium" id="delete">
            <div className="flex flex-row items-center gap-2 cursor-pointer" id="delete">
              Удалены
            </div>
          </th>
        </tr>
      </thead>
      <tbody className="divide-y divide-gray-200 items-center justify-center align-middle">
        {currentItems.map((item) => (
          <tr key={item.key}>
            <td className="pr-2 py-4 whitespace-nowrap text-sm text-gray-800 hidden md:table-cell">{item.num}</td>
            <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-800">
              <p className="block md:hidden">{item.num}</p>
              <Link to={`/user/${item.num}`}>
                {item.name}
                <br />
                <span className="inline-block text-gray-400 text-xs -translate-y-[2px]">{item.email}</span>
              </Link>
            </td>

            <td className="px-2 py-4 whitespace-nowrap text-center text-sm text-gray-800">{item.active}</td>
            <td className="px-2 py-4 whitespace-nowrap text-center text-sm text-gray-800">{item.activeHR}</td>
            <td className="px-2 py-4 whitespace-nowrap text-center text-sm text-gray-800">{item.moderation}</td>
            <td className="px-2 py-4 whitespace-nowrap text-center text-sm text-gray-800">{item.inactive}</td>
            <td className="pl-2 py-4 whitespace-nowrap text-center text-sm text-gray-800">{item.delete}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default ListAll;
